import { Component, JSX } from 'solid-js';

interface ControlMenuSubmenuProps {
  parentOpensUpward?: boolean;
  children: JSX.Element;
}

export const ControlMenuSubmenu: Component<ControlMenuSubmenuProps> = (
  props
) => {
  const submenuVerticalClass = (): string =>
    props.parentOpensUpward ? 'bottom-0' : 'top-0';

  return (
    <div
      class={`absolute left-full ${submenuVerticalClass()} bg-base-page min-w-[150px] rounded-sm shadow-lg z-50`}
    >
      {props.children}
    </div>
  );
};
